import { getMessage } from '../i18n/i18nWrapper';
import countriesList from './countries.json';

export const countryList = () => {
  const countriesValued = countriesList.countries.map(country => {
    country.value = getMessage(`country.${country.id}`);
    return country;
  });
  return countriesValued;

  /* The following countries was commented on the list of them.
     If you need it, please add the countries to the countries.json file.
    Embargoed Country
    {
      "id": "CU",
      "supported": false
    },
    Embargoed Country
    {
      "id": "IR",
      "supported": false
    },
    Embargoed Country
    {
      "id": "KP",
      "supported": false
    },
    Embargoed Country
    {
      "id": "RU",
      "supported": false
    },
    Embargoed Country
    {
      "id": "SD",
      "supported": false
    },
    Embargoed Country
    {
      "id": "SY",
      "supported": false
    },
  */
};

// used to sort the countries in the countryList.
function countryCompareFunction(country1, country2) {
  if (country1.value > country2.value) {
    return 1;
  } else if (country1.value === country2.value) {
    return 0;
  }
  return -1;
}

export function getSortedCountryList() {
  const supportedCountries = countryList().filter(country => {
    return country.supported;
  });

  const nonSupportedCountries = countryList().filter(country => {
    return !country.supported;
  });

  return [
    {
      options: [...supportedCountries].sort(countryCompareFunction),
      title: getMessage('registration.supportedGeographies')
    },
    {
      options: [...nonSupportedCountries].sort(countryCompareFunction),
      title: getMessage('registration.nonsupportedGeographies')
    }
  ];
}